var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-20 py-md-30 border-bottom border-color-light"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2",
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "px-20 pr-sm-0"
  }, [_c('p', {
    staticClass: "page-text--sm font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")])])]), _c('v-col', {
    staticClass: "mt-n14 mt-sm-0",
    attrs: {
      "cols": "12",
      "sm": "10",
      "data-aos": "fade-left"
    }
  }, [_c('div', {
    staticClass: "px-20 pl-sm-0"
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-grey-7"
  }, [_vm._t("default")], 2)])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }